import React from 'react';
import { AnimateOnScroll } from './AnimateOnScroll';
export function WhyChooseUsSection() {
  return <section className="bg-[#E8E8E8] py-24 lg:py-32" data-id="element-247">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-248">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" data-id="element-249">
          {/* Left Column - Headline (40%) */}
          <AnimateOnScroll className="w-full lg:w-[40%]" data-id="element-250">
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-black uppercase leading-[1.05]" data-id="element-251">
              WHY
              <br data-id="element-252" />
              CHOOSE US
            </h2>
          </AnimateOnScroll>

          {/* Right Column - Body Text (55%) */}
          <AnimateOnScroll className="w-full lg:w-[55%]" delay={200} data-id="element-253">
            <img src="https://cdn.magicpatterns.com/uploads/eFn36SSwVd8WzHStva2Ksd/Vector_12.png" alt="" className="mb-8" style={{
            width: '18px',
            height: '15px'
          }} data-id="element-254" />

            <div className="space-y-8 font-body text-base text-gray-700 leading-relaxed" data-id="element-255">
              <p data-id="element-256">
                Discover the heart of Be CLINICAL—our team. With providers like
                Dr. Fiona Frie leading the way, we're a collective of experts
                passionate about enhancing your beauty and wellness.
              </p>
              <p data-id="element-257">
                Each member brings{' '}
                <strong className="text-black" data-id="element-258">specialized skills</strong> and a
                deep commitment to personalized care, ensuring your experience
                is not just effective but truly{' '}
                <strong className="text-black" data-id="element-259">transformative</strong>. Join us
                and see how our expertise becomes your beauty breakthrough.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}